import {BlockFactory} from './block-factory/blockFactory';
console.log('ceva2 2', BlockFactory);